
import Spinner from 'react-bootstrap/Spinner';

function Loading(){
    return <div className="floating-modal loading" style={{ minWidth: "30vw" }}>
            <Spinner animation="border" role="status">
        <span className="visually-hidden">...</span>
        </Spinner>
        Loading
    </div>
}

export default Loading;